export interface ISearchItem {
  id: number;
  title: string;
  description: string;
  path: string;
  sectionId?: string;
  tab?: string;
}

export const searchItems: ISearchItem[] = [
  {
    id: 1,
    title: "Dashboard",
    description: "Total Registered Cooperatives",
    path: "/",
    sectionId: "total-registered",
  },
  {
    id: 2,
    title: "Dashboard",
    description: "Types of Cooperatives",
    path: "/",
    sectionId: "types-of-cooperatives",
  },
  {
    id: 3,
    title: "Dashboard",
    description: "Onboarding Applicants",
    path: "/",
    sectionId: "onboarding-applicants",
  },
  {
    id: 4,
    title: "Dashboard",
    description: "Registration Statistics",
    path: "/",
    sectionId: "registration-statistics",
  },
  {
    id: 5,
    title: "Dashboard",
    description: "Complaint Statistics",
    path: "/",
    sectionId: "complaint-statistics",
  },
  {
    id: 6,
    title: "Dashboard",
    description: "Latest Registered",
    path: "/",
    sectionId: "latest-registered",
  },
  {
    id: 9,
    title: "Dashboard",
    description: "Cooperative Name",
    path: "/",
    sectionId: "latest-registered",
  },
  {
    id: 10,
    title: "Dashboard",
    description: "PAN Number",
    path: "/",
    sectionId: "latest-registered",
  },
  {
    id: 11,
    title: "Dashboard",
    description: "Email Address",
    path: "/",
    sectionId: "latest-registered",
  },
  {
    id: 12,
    title: "Dashboard",
    description: "Mobile Number",
    path: "/",
    sectionId: "latest-registered",
  },
  {
    id: 13,
    title: "Dashboard",
    description: "Cooperative Status",
    path: "/",
    sectionId: "latest-registered",
  },
  {
    id: 14,
    title: "Dashboard",
    description: "Nature of Work",
    path: "/",
    sectionId: "latest-registered",
  },
  {
    id: 18,
    title: "Cooperative",
    description: "Cooperatives List",
    path: "/cooperatives-list",
    sectionId: "cooperatives-list",
  },
  {
    id: 19,
    title: "Cooperative",
    description: "Register Here",
    path: "/cooperatives-list",
    sectionId: "cooperatives-list",
  },
  {
    id: 20,
    title: "Cooperative",
    description: "Apply filters",
    path: "/cooperatives-list",
    sectionId: "cooperative-filters",
  },
  {
    id: 26,
    title: "Cooperative",
    description: "Registration Number",
    path: "/cooperatives-list",
    sectionId: "cooperative-table",
  },
  {
    id: 27,
    title: "Cooperative",
    description: "Business Registration Number",
    path: "/cooperatives-list",
    sectionId: "cooperative-table",
  },
  {
    id: 28,
    title: "Cooperative",
    description: "Cooperative Name",
    path: "/cooperatives-list",
    sectionId: "cooperative-table",
  },
  {
    id: 29,
    title: "Cooperative",
    description: "PAN Number",
    path: "/cooperatives-list",
    sectionId: "cooperative-table",
  },
  {
    id: 30,
    title: "Cooperative",
    description: "Email Address",
    path: "/cooperatives-list",
    sectionId: "cooperative-table",
  },
  {
    id: 31,
    title: "Cooperative",
    description: "Mobile Number",
    path: "/cooperatives-list",
    sectionId: "cooperative-table",
  },
  {
    id: 32,
    title: "Cooperative",
    description: "Cooperative Status",
    path: "/cooperatives-list",
    sectionId: "cooperative-table",
  },
  {
    id: 34,
    title: "Cooperative",
    description: "Nature of Work",
    path: "/cooperatives-list",
    sectionId: "cooperative-table",
  },
  {
    id: 37,
    title: "Complaints",
    description: "Create Complaint",
    path: "/complaints/create",
  },
  {
    id: 40,
    title: "Complaints",
    description: "Total Complaints Registered",
    path: "/complaints",
    sectionId: "total-complaints",
  },
  {
    id: 42,
    title: "Complaints",
    description: "Types of Complaints",
    path: "/complaints",
    sectionId: "complaint-types",
  },
  {
    id: 44,
    title: "Complaints",
    description: "Complaints Processing",
    path: "/complaints",
    sectionId: "complaints-processing",
  },
  {
    id: 45,
    title: "Complaints",
    description: "Processing Complaints",
    path: "/complaints",
    sectionId: "complaints-processing",
  },
  {
    id: 49,
    title: "Complaints",
    description: "Complaint Title",
    path: "/complaints",
    sectionId: "complaints-table",
  },
  {
    id: 50,
    title: "Complaints",
    description: "Cooperative Name",
    path: "/complaints",
    sectionId: "complaints-table",
  },
  {
    id: 51,
    title: "Complaints",
    description: "Complaint Category",
    path: "/complaints",
    sectionId: "complaints-table",
  },
  {
    id: 52,
    title: "Complaints",
    description: "Filed Date",
    path: "/complaints",
    sectionId: "complaints-table",
  },
  {
    id: 53,
    title: "Complaints",
    description: "Complaint Priority",
    path: "/complaints",
    sectionId: "complaints-table",
  },
  {
    id: 54,
    title: "Complaints",
    description: "Complaint Status",
    path: "/complaints",
    sectionId: "complaints-table",
  },
  {
    id: 59,
    title: "Notice",
    description: "Notices List",
    path: "/notices",
    sectionId: "notice-header",
  },
  {
    id: 60,
    title: "Notice",
    description: "Create New Notice",
    path: "/notices/create",
  },
  {
    id: 61,
    title: "Notice",
    description: "Notice Posted This Month",
    path: "/notices",
    sectionId: "notice-posted-month",
  },
  {
    id: 62,
    title: "Notice",
    description: "Types of Notice",
    path: "/notices",
    sectionId: "notice-types",
  },
  {
    id: 63,
    title: "Notice",
    description: "Notice Archive",
    path: "/notices",
    sectionId: "notice-archive",
  },
  {
    id: 64,
    title: "Notice",
    description: "Notice Management",
    path: "/notices",
    sectionId: "notice-table",
  },
  {
    id: 67,
    title: "Notice",
    description: "Notice Title",
    path: "/notices",
    sectionId: "notice-table",
  },
  {
    id: 68,
    title: "Notice",
    description: "Notice Type",
    path: "/notices",
    sectionId: "notice-table",
  },
  {
    id: 69,
    title: "Notice",
    description: "Notice Details",
    path: "/notices",
    sectionId: "notice-table",
  },
  {
    id: 70,
    title: "Notice",
    description: "Notice Status",
    path: "/notices",
    sectionId: "notice-table",
  },
  {
    id: 75,
    title: "User",
    description: "Add New User",
    path: "/user/add",
    sectionId: "user-header",
  },
  {
    id: 77,
    title: "User",
    description: "User Management",
    path: "/user",
    sectionId: "user-table",
  },
  {
    id: 78,
    title: "User",
    description: "Username",
    path: "/user",
    sectionId: "user-table",
  },
  {
    id: 79,
    title: "User",
    description: "Email Address",
    path: "/user",
    sectionId: "user-table",
  },
  {
    id: 80,
    title: "User",
    description: "User Role",
    path: "/user",
    sectionId: "user-table",
  },
  {
    id: 81,
    title: "User",
    description: "User Status",
    path: "/user",
    sectionId: "user-table",
  },
  {
    id: 82,
    title: "User",
    description: "Last Login",
    path: "/user",
    sectionId: "user-table",
  },
  {
    id: 84,
    title: "Settings",
    description: "General",
    path: "/settings",
    tab: "general",
  },
  {
    id: 85,
    title: "Settings",
    description: "Notification",
    path: "/settings",
    tab: "notification",
  },
  {
    id: 86,
    title: "Settings",
    description: "Security",
    path: "/settings",
    tab: "security",
  },
  {
    id: 87,
    title: "Admin Page",
    description: "Admin Control",
    path: "/admin",
    sectionId: "admin-header",
  },
  {
    id: 88,
    title: "Admin Page",
    description: "Dropdown Options",
    path: "/admin",
    tab: "dropdown",
  },
  {
    id: 89,
    title: "Admin Page",
    description: "Status Management",
    path: "/admin",
    tab: "status",
  },
  {
    id: 90,
    title: "Admin Page",
    description: "Role and Permissions",
    path: "/admin",
    tab: "role",
  },
  {
    id: 91,
    title: "Admin Page",
    description: "Nature of Work / Notice Audience",
    path: "/admin",
    tab: "dropdown",
    sectionId: "Nature of Work",
  },
  {
    id: 92,
    title: "Admin Page",
    description: "Working Area",
    path: "/admin",
    tab: "dropdown",
    sectionId: "Working Area",
  },
  {
    id: 93,
    title: "Admin Page",
    description: "Registration Area",
    path: "/admin",
    tab: "dropdown",
    sectionId: "Registration Area",
  },
  {
    id: 94,
    title: "Admin Page",
    description: "Province",
    path: "/admin",
    tab: "dropdown",
    sectionId: "Province",
  },
  {
    id: 95,
    title: "Admin Page",
    description: "District",
    path: "/admin",
    tab: "dropdown",
    sectionId: "District",
  },
  {
    id: 96,
    title: "Admin Page",
    description: "Ward",
    path: "/admin",
    tab: "dropdown",
    sectionId: "Ward",
  },
  {
    id: 97,
    title: "Admin Page",
    description: "Committee Type",
    path: "/admin",
    tab: "dropdown",
    sectionId: "Committee Type",
  },
  {
    id: 98,
    title: "Admin Page",
    description: "Committee Position",
    path: "/admin",
    tab: "dropdown",
    sectionId: "Committee Position",
  },
  {
    id: 99,
    title: "Admin Page",
    description: "Executive Position",
    path: "/admin",
    tab: "dropdown",
    sectionId: "Executive Position",
  },
  {
    id: 100,
    title: "Admin Page",
    description: "Position Status",
    path: "/admin",
    tab: "dropdown",
    sectionId: "Position Status",
  },
  {
    id: 101,
    title: "Admin Page",
    description: "Education Level",
    path: "/admin",
    tab: "dropdown",
    sectionId: "Education Level",
  },
  {
    id: 102,
    title: "Admin Page",
    description: "Gender",
    path: "/admin",
    tab: "dropdown",
    sectionId: "Gender",
  },
  {
    id: 103,
    title: "Admin Page",
    description: "Fiscal Year",
    path: "/admin",
    tab: "dropdown",
    sectionId: "Fiscal Year",
  },
  {
    id: 104,
    title: "Admin Page",
    description: "Complaint Type",
    path: "/admin",
    tab: "dropdown",
    sectionId: "Complaint Type",
  },
  {
    id: 105,
    title: "Admin Page",
    description: "Complaint Priority",
    path: "/admin",
    tab: "dropdown",
    sectionId: "Complaint Priority",
  },
  {
    id: 106,
    title: "Admin Page",
    description: "Notice Type",
    path: "/admin",
    tab: "dropdown",
    sectionId: "Notice Type",
  },
  // {
  //   id: 107,
  //   title: "Admin Page",
  //   description: "Notice Audience",
  //   path: "/admin",
  //   tab: "dropdown",
  //   sectionId: "Notice Audience",
  // },
  {
    id: 108,
    title: "Admin Page",
    description: "Municipality (Local Level)",
    path: "/admin",
    tab: "dropdown",
    sectionId: "Municipality (Local Level)",
  },
  {
    id: 109,
    title: "Admin Page",
    description: "Cooperative Statuses",
    path: "/admin",
    tab: "status",
    sectionId: "Cooperative Statuses",
  },
  {
    id: 110,
    title: "Admin Page",
    description: "Complaint Statuses",
    path: "/admin",
    tab: "status",
    sectionId: "Complaint Statuses",
  },
  {
    id: 111,
    title: "Admin Page",
    description: "Notice Statuses",
    path: "/admin",
    tab: "status",
    sectionId: "Notice Statuses",
  },
  {
    id: 112,
    title: "Admin Page",
    description: "User Statuses",
    path: "/admin",
    tab: "status",
    sectionId: "User Statuses",
  },
];
